module.exports = __webpack_public_path__ + "img/fullrate.0581504e.svg";